var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlertYellowCircle = function SvgAlertYellowCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.832 9.332a1.167 1.167 0 0 1 2.333 0v5.833a1.167 1.167 0 0 1-2.333 0V9.332Zm0 9.333a1.167 1.167 0 1 1 2.334.001 1.167 1.167 0 0 1-2.334 0Zm1.167 4.667c-5.146 0-9.334-4.187-9.334-9.333S8.853 4.665 14 4.665 23.332 8.853 23.332 14s-4.187 9.333-9.333 9.333Zm0-21c-6.444 0-11.667 5.223-11.667 11.667 0 6.443 5.223 11.666 11.667 11.666 6.443 0 11.666-5.223 11.666-11.666 0-6.444-5.223-11.667-11.666-11.667Z",
    fill: "#F3A800"
  })));
};
export default SvgAlertYellowCircle;